import { render } from "./Sylhet.vue?vue&type=template&id=2a913ae3"
import script from "./Sylhet.vue?vue&type=script&lang=js"
export * from "./Sylhet.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/teachers.gov.bd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__